import { Toolbar, ToolbarButton } from "@mui/x-data-grid";
import { Typography, Divider, Tooltip, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import "../customToolbar/CustomToolbar.css";

export default function AdminGridToolbar({ title, onNew, onEdit, onDelete, canEdit, canDelete }) {
  return (
    <Toolbar className="nfeToolbar">
      <Typography className="gridTitle" sx={{ flex: 1, mx: 0.5 }}>
        {title}
      </Typography>

      <Box className="toolbarLeft">
        <ToolbarButton className="sapLinkBtn" onClick={onNew}>
          <AddIcon fontSize="small" />
          Novo
        </ToolbarButton>

        <Tooltip title={!canEdit ? "Selecione uma linha para editar" : ""}>
          <span>
            <ToolbarButton className="sapLinkBtn" disabled={!canEdit} onClick={onEdit}>
              <EditIcon fontSize="small" />
              Editar
            </ToolbarButton>
          </span>
        </Tooltip>

        <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 0.5 }} />

        <Tooltip title={!canDelete ? "Selecione ao menos uma linha para excluir" : ""}>
          <span>
            <ToolbarButton
              className="sapLinkBtn"
              disabled={!canDelete}
              onClick={onDelete}
              sx={{ color: canDelete ? "error.main" : undefined }}
            >
              <DeleteIcon fontSize="small" />
              Excluir
            </ToolbarButton>
          </span>
        </Tooltip>
      </Box>
    </Toolbar>
  );
}
